import type { SpotlightCandidate } from "./select-spotlight";

let snapshot: (() => SpotlightCandidate[]) | null = null;

export function registerVisibleFeedSnapshot(
    fn: () => SpotlightCandidate[],
): () => void {
    snapshot = fn;
    return () => {
        if (snapshot === fn) snapshot = null;
    };
}

export function hasVisibleFeed(): boolean {
    return snapshot !== null;
}

export function getVisibleFeedDogs(): SpotlightCandidate[] {
    return snapshot?.() ?? [];
}
